import { useTranslation } from 'react-i18next';
import { RHFSelect, RHFSwitch } from 'src/components/hook-form';
import { FormInnerContainer, FormItem, FormLabel, FormRow } from 'src/layouts/form/FormLayout';
import { useStores } from 'src/models';
import { DYNAMIC_TYPE_CODE } from 'src/static/constants';

interface IBasicInfoProps {
  categorySelectOptions: { value: number; label: string }[];
}

export const BasicInfo = ({ categorySelectOptions }: IBasicInfoProps) => {
  const { t } = useTranslation();
  const { commonCodeStore } = useStores();
  const ctgyDpTypeCdOptions = commonCodeStore.getDynamicCodeById(DYNAMIC_TYPE_CODE.SCREEN);
  return (
    <FormInnerContainer>
      <FormLabel>{t('common.form.section.basicInfo')}</FormLabel>
      <FormRow sx={{ gridTemplateColumns: '1fr 1fr 1fr' }}>
        {/* 카테고리 타입 */}
        <FormItem>
          <RHFSelect
            label={t('category.form.ctgyDpTypeCd')}
            name="ctgyDpTypeCd"
            options={ctgyDpTypeCdOptions}
            useAll={false}
          />
        </FormItem>
        {/* 상위 카테고리 */}
        <FormItem>
          <RHFSelect
            label={t('category.form.categoryPsid')}
            name="categoryPsid"
            options={categorySelectOptions}
            useAll={false}
          />
        </FormItem>
        {/* 사용 여부 */}
        <FormItem>
          <RHFSwitch label={t('category.form.useYn')} name="useYn" />
        </FormItem>
      </FormRow>
    </FormInnerContainer>
  );
};
